import { defineStore } from 'pinia'
import { ref } from 'vue'
import { apiCreateOrder } from './payment-api'

type QrModalPayload = {
  orderId: string
  codeUrl: string
  price: string
  credit: number
  skuId: string
  expiredTime: number
  orderTime: number
}

export const usePaymentStore = defineStore('payment', () => {
  const purchaseModalVisible = ref(false)
  const qrModalVisible = ref(false)
  const resultModalVisible = ref(false)
  const resultSuccess = ref(true)

  const currentOrderId = ref('')
  const currentCodeUrl = ref('')
  const currentPrice = ref('')
  const currentCredit = ref(0)
  const selectedSkuId = ref('')
  const currentExpiredTime = ref(0)
  const currentOrderTime = ref(0)
  const openPurchaseModal = () => {
    purchaseModalVisible.value = true
  }

  const closePurchaseModal = () => {
    purchaseModalVisible.value = false
  }

  const openQrModal = (payload: QrModalPayload) => {
    purchaseModalVisible.value = false
    currentOrderId.value = payload.orderId
    currentCodeUrl.value = payload.codeUrl
    currentPrice.value = payload.price
    currentCredit.value = payload.credit
    selectedSkuId.value = payload.skuId
    currentExpiredTime.value = payload.expiredTime
    currentOrderTime.value = payload.orderTime
    qrModalVisible.value = true
  }

  const closeQrModal = () => {
    qrModalVisible.value = false
    currentOrderId.value = ''
    currentCodeUrl.value = ''
    currentPrice.value = ''
    currentCredit.value = 0
    selectedSkuId.value = ''
    currentExpiredTime.value = 0
    currentOrderTime.value = 0
    purchaseModalVisible.value = true
  }

  const handleQrSuccess = () => {
    qrModalVisible.value = false
    resultSuccess.value = true
    resultModalVisible.value = true
  }

  const handleQrFailure = () => {
    qrModalVisible.value = false
    resultSuccess.value = false
    resultModalVisible.value = true
  }

  const openResultModal = (success: boolean) => {
    resultSuccess.value = success
    resultModalVisible.value = true
  }

  const closeResultModal = () => {
    const wasSuccess = resultSuccess.value
    resultModalVisible.value = false
    if (wasSuccess) {
      purchaseModalVisible.value = false
    } else {
      purchaseModalVisible.value = true
    }
  }

  const refreshQrOrder = async () => {
    if (!selectedSkuId.value) return
    try {
      const res = await apiCreateOrder({ sku_id: selectedSkuId.value })
      if (res?.data?.order_id && res?.data?.code_url) {
        currentOrderId.value = res.data.order_id
        currentCodeUrl.value = res.data.code_url
        if (res.data.expire_time != null) currentExpiredTime.value = res.data.expire_time
        if (res.data.server_time != null) currentOrderTime.value = res.data.server_time
        return true
      }
    } catch {
      // 错误由 http-client 统一提示
    }
    return false
  }

  return {
    purchaseModalVisible,
    qrModalVisible,
    resultModalVisible,
    resultSuccess,
    currentOrderId,
    currentCodeUrl,
    currentPrice,
    currentCredit,
    selectedSkuId,
    currentExpiredTime,
    currentOrderTime,
    openPurchaseModal,
    closePurchaseModal,
    openQrModal,
    closeQrModal,
    handleQrSuccess,
    handleQrFailure,
    openResultModal,
    closeResultModal,
    refreshQrOrder,
  }
})
